<template>
  <div class="container">
    <el-card shadow="always" style="width:100%;">
      <el-form style="width:50%;" label-width="120px" :label-position="labelPosition" size="small" :model="formModel">
        <el-row>
          <el-col>
            <el-form label-width="120px" :label-position="labelPosition" size="small" :model="query">
              <el-form-item prop="title" label="图书ISBN(编号)">
                <el-row>
                  <el-col :span="12">
                    <el-input v-model="query.StrISBN" @keyup.enter="onSubmit"/>
                  </el-col>
                  <el-col :span="12">
                    <el-button type="primary" size="mini" style="margin-left:10px" icon="el-icon-search" @click="onSubmit" >查询</el-button>
                    <el-button type="warning" size="mini" style="margin-left:10px" icon="el-icon-refresh-right" @click="clearData">清空</el-button>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col>
            <el-form-item prop="title" label="正题名(书名)">
              <el-input v-model="formModel.StrPositiveTitle" />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item prop="title" label="第一责任者">
              <el-input v-model="formModel.StrFirstResponsible" />
            </el-form-item>
          </el-col>
<!--          <el-col>-->
<!--            <el-form-item prop="title" label="ISBN(统一)书号">-->
<!--              <el-input v-model="formModel.StrISBN" />-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col>
            <el-form-item prop="title" label="单价">
              <el-input v-model="formModel.FloatPricePer" />
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item prop="publish" label="出版社">
              <el-input v-model="formModel.StrPublisher" />
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item prop="place" label="出版地">
              <el-input v-model="formModel.StrPublisherPlace" />
            </el-form-item>
          </el-col>


          <el-col>
            <el-form-item prop="data" label="出版时间">
              <el-input v-model="formModel.StrPublicationDate" />
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item prop="pages" label="页数">
              <el-input v-model="formModel.StrNumberPages" />
            </el-form-item>
          </el-col>


<!--          <el-col>-->
<!--            <el-form-item prop="title" label="书屋位置(书屋位置)">-->
<!--              <el-select v-model="formModel.StrLibraryID" placeholder="请选择">-->
<!--                <el-option-->
<!--                    v-for="item in swList"-->
<!--                    :key="item.StrID"-->
<!--                    :label="item.StrName"-->
<!--                    :value="item.StrID"-->
<!--                />-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col>
            <el-form-item prop="StrTypeName" label="分类号" :rules="rules.StrTypeName">
              <el-input v-model="formModel.StrTypeName" />
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item prop="StrBookNumber" label="种次号" :rules="rules.StrBookNumber">
              <el-input v-positive-number type="number" v-model="formModel.StrBookNumber"/>
              <span style="color: red; font-size: 12px; display: block;">如果删除种次号，将由系统自动生成种次号</span>
            </el-form-item>
          </el-col>


          <el-col v-show="isShow === true">
            <span>共 {{total}} 本图书</span>
          </el-col>

          <el-col>
            <el-form-item>
              <el-button
                  class="filter-item"
                  style="margin-left: 10px;"
                  type="primary"
                  icon="el-icon-edit"
                  @click="handleUpdate"
              >修改</el-button>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import {ElMessage, ElMessageBox} from "element-plus";
import {BASE_URL} from "@/utils/constants";
export default {
  name:'Proofreading',
  data() {
    return {
      Rawvalue:{
        bookNumber:'', //原始种次号
        typeName:'',  //原始分类号
      },
      isShow:false,
      total:0,
      checked: true,
      labelPosition: 'right',
      formModel: {},
      query: {},
      swList: [],
      rules: {
        StrBookNumber: [
          {
            type: 'number',
            validator: (rule, value, callback) => {
              // 允许值为空（null, undefined, 或空字符串）
              if (value === null || value === undefined || value === '') {
                callback(); // 为空时通过验证
              } else if (value <= 0) {
                callback(new Error('种次号必须大于 0')); // 非空且小于等于 0 时提示错误
              } else {
                callback(); // 非空且大于 0 时通过验证
              }
            },
            trigger: 'blur',
          },
        ],
        StrTypeName: [
          { required: true, message: '分类号不能为空', trigger: 'blur' },
        ],
      },
    }
  },
  directives: {
    positiveNumber: {
      bind(el) {
        const input = el.querySelector('input');
        input.addEventListener('input', function () {
          let value = input.value.replace(/[^0-9]/g, '').replace(/^0+/, '');
          const num = Number(value);
          if (!value || num <= 0) {
            input.value = '';
          } else {
            input.value = value;
          }
          // 触发 v-model 更新
          input.dispatchEvent(new Event('input'));
        });
      },
    },
  },
  created() {
    this.getSWList()
  },
  methods: {
    clearData()
    {
      this.formModel = {}
      this.query = {}
      this.isShow = false
      this.total = 0
    },
    // 获取书屋列表
    getSWList() {
      this.$axios({
        url: BASE_URL + 'librarys',
        method: 'get',
        //发送格式为json
        headers:
            {
              'Content-Type': 'application/json',
              'dataType': 'json',
              'Authorization': localStorage.getItem("token")
            }
      }).then((res) => {
        if (res.data.ok) {
          this.swList = res.data.msg
        }else{
          this.$message({
            message:res.data.msg,
            type: 'error'
          })
        }
      })
    },
    // 提交
    onSubmit() {
      this.$axios({
        url: BASE_URL + 'books/isbn/'+this.query.StrISBN,
        method: 'get',
        //发送格式为json
        headers:
            {
              'Content-Type': 'application/json',
              'dataType': 'json',
              'Authorization': localStorage.getItem("token")
            }
      }).then(res => {
        if (res.data.ok) {
          this.formModel = res.data.msg.book
          this.Rawvalue.bookNumber = res.data.msg.book.StrBookNumber
          this.Rawvalue.typeName = res.data.msg.book.StrTypeName
          // console.log("看看保存的原始数据",this.Rawvalue.typeName, this.Rawvalue.bookNumber)
          this.total = res.data.msg.total
          this.isShow = true
        } else {
          this.$notify({
            title: '提示',
            type: 'info',
            message: res.data.msg
          })
        }
      })
    },
    // 编辑
    handleUpdate() {
      if(this.isShow === false)
      {
        return
      }
      if(parseInt(this.formModel.StrBookNumber)<0){
        return;
      }
      if(this.formModel.StrTypeName === '' || this.formModel.StrTypeName === null || this.formModel.StrTypeName === undefined){
        return;
      }
      ElMessageBox.confirm(
          '确定要对这'+this.total+'本图书进行修改吗？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      )
          .then(() => {
            this.formModel.FloatPricePer=this.formModel.FloatPricePer.toString()
            if(this.formModel.StrBookNumber === '' || this.formModel.StrBookNumber === null || this.formModel.StrBookNumber === undefined)
            {
              this.formModel.StrBookNumber = '-1'
              this.formModel.ModifyBookNumber = true
            }else if(this.formModel.StrBookNumber === this.Rawvalue.bookNumber && this.formModel.StrTypeName === this.Rawvalue.typeName){
              this.formModel.ModifyBookNumber = false
            }else {
              this.formModel.ModifyBookNumber = true
            }

            console.log("种次号对比："+this.formModel.StrBookNumber +"==="+this.Rawvalue.bookNumber)
            console.log("分类号对比："+this.formModel.StrTypeName +"==="+this.Rawvalue.typeName)


            this.$axios({
              url: BASE_URL + 'books/batchUpdateBookInfo',
              method: 'post',
              data:JSON.stringify(this.formModel),
              //发送格式为json
              headers:
                  {
                    'Content-Type': 'application/json',
                    'dataType': 'json',
                    'Authorization': localStorage.getItem("token")
                  }
            }).then(res => {
              if (res.data.ok) {
                this.$message({
                  message:res.data.msg,
                  type: 'success'
                })
                // this.getList()
                // if(this.formModel.StrBookNumber === '-1')
                // {
                //   this.formModel.StrBookNumber = ''
                // }
                this.onSubmit()
              }else{
                this.$message({
                  message:res.data.msg,
                  type: 'error'
                })
              }
            })
            // this.formModel = {}
            // this.query = {}
            // this.isShow = false
            // this.total = 0
          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: '取消校对',
            })
          })
    }
  }
}
</script>
<style scoped>

</style>
